import React from 'react'
import { NavLink } from 'react-router-dom';
import styled from 'styled-components'
import { TabletSize } from '../responsive/TabletSize';

const Logo = styled(NavLink)`
    text-decoration: none;
    display: inline-block;
    color: ${props => props.click ? props.theme.body : props.theme.text};
    font-family: 'Pattaya', sans-serif;
    font-size: 28px;
    cursor: pointer;

    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 3;
    ${TabletSize({ fontSize: "25px", left: "15px" })}
`;

export const MyLogo = ({ click }) => {
  return (
    <Logo click={click} to="/" >&#60;Bondeth/&#62;</Logo>
  )
}